module.exports = "<router-outlet></router-outlet><div class=\"container\"><footer class=\"center-align\"><p>Todos los derechos reservados | Consejo Nacional para Prevenir la Discriminación | DATA4 | 2019</p></footer></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/enadis-compare/enadis-compare.component.html
// module id = ./src/app/enadis-compare/enadis-compare.component.html
// module chunks = main